import React from 'react';
import ReactDOM from 'react-dom';
import CloseIcon from 'static/images/close.svg';
import styles from './Modal.css';

class Modal extends React.Component {
  componentDidMount() {
    document.addEventListener('mousedown', this.handleOverlayClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOverlayClick);
  }

  handleOverlayClick = e => {
    if (this.overlayRef && this.overlayRef.isSameNode(e.target)) {
      this.handleCloseModal();
    }
  };

  handleCloseModal = () => {
    const { onClose } = this.props;
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  render() {
    const { children, className, modalRoot, showModal, title } = this.props;

    return showModal
      ? ReactDOM.createPortal(
          <div
            ref={node => {
              this.overlayRef = node;
            }}
            className={styles.overlay}
          >
            <div className={`${styles.modal} ${className}`}>
              <div className={styles.header}>
                <span>{title}</span>
                <button
                  type="button"
                  className={styles.closeButton}
                  onClick={this.handleCloseModal}
                >
                  <span className={styles.closeButtonLabel}>Close</span>
                  <CloseIcon />
                </button>
              </div>
              <div className={styles.body}>{children}</div>
            </div>
          </div>,
          document.getElementById(modalRoot || 'modal-root'),
        )
      : null;
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/components/Modal/Modal.jsx